let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3NTQl")).then(() => parcelRequire('1fbyN'));